import type { MapSettings, MindMapNode } from './types';
import { generateId } from '@/utils/id';

export function createDefaultNode(
  overrides: Partial<MindMapNode> & { id?: string } = {},
): MindMapNode {
  return {
    id: overrides.id ?? generateId(),
    parentId: null,
    childIds: [],
    text: '',
    notes: '',
    collapsed: false,
    ...overrides,
  };
}

export function createRootNode(title = 'Central Idea'): MindMapNode {
  return createDefaultNode({ text: title });
}

export const DEFAULT_SETTINGS: MapSettings = {
  layoutType: 'horizontal-tree',
  horizontalGap: 80,
  verticalGap: 16,
  themeId: 'default',
};
